import { z } from 'zod';
import { DEFAULT_LEDGER_YEAR, LedgerYear } from '../-zod-schema';
export const LedgerDetailSearchSchema = z.object({
  ledgerYear: LedgerYear.default(DEFAULT_LEDGER_YEAR)
});
export type LedgerDetailSearchParams = z.infer<typeof LedgerDetailSearchSchema>;